import { render, staticRenderFns } from "./ServicioDetalleWebApp.vue?vue&type=template&id=0b679be6&"
import script from "./ServicioDetalleWebApp.vue?vue&type=script&lang=js&"
export * from "./ServicioDetalleWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports